var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"from-item"},[_c('div',{staticClass:"from-item-num"},[_vm._v(_vm._s(_vm.num))]),_c('div',{staticClass:"from-item-name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"from-item-main"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }